import { useState } from "react";
import type { RuleWizardStep, RuleWizardSummaryPart } from "../ruleWizard.type";

// "Every visit" -> "every visit", but "VIP customers" stays as it is.
const lowerFirst = (value: string) =>
  /^[A-Z][A-Z]/.test(value)
    ? value
    : value.charAt(0).toLowerCase() + value.slice(1);

// One selected option per step; the summary is derived from the selection.
export function useRuleWizard(steps: RuleWizardStep[]) {
  const initialState = {
    selected: Object.fromEntries(
      steps.map((step) => [step.key, step.defaultOption ?? step.options[0]]),
    ) as Record<string, string>,
  };
  const [state, setState] = useState(initialState);

  const select = (key: string, option: string) =>
    setState((state) => ({
      ...state,
      selected: { ...state.selected, [key]: option },
    }));

  const summary: RuleWizardSummaryPart[] = steps.map((step) => {
    const value = state.selected[step.key];
    return {
      label: step.summaryLabel,
      value: step.lowerFirstInSummary ? lowerFirst(value) : value,
    };
  });

  return { selected: state.selected, select, summary };
}
